$(window).load(function () {


	// @see example http://flexslider.woothemes.com/thumbnail-slider.html

	$.getScript("/fileadmin/bod/html/javascripts/vendor/jquery.flexslider-min.js", function () {

		$('.smsThumbnailGallery > .smsthumbnailgallery-flexslider').each(function (slider) {
			function changeHeight(context) {
				var height = $('li.flex-active-slide img.smsThumbnailGalerie__image', that).height() + 20;
				$('ol.flex-control-nav', context).each(function (slider) {
					$(this).css("top", height + "px");
					$(this).css("bottom", "");
					$(this).removeClass('hide');
				});
			};

			$(".accordion-item .smsThumbnailGallery").each(function (index, domEle) {
				$(this).parent().prev(".accordion-headlines").click(function () {
					setTimeout(function() {
						that.data("flexslider").doMath();
					}, 100);
					setTimeout(function() {
						changeHeight(that);
					}, 150);
				});
			});

			var that = $(this);

			if ($(this).data('slider')) {
				$(this).flexslider({
					// Carousel
					animation: "slide",
					animationLoop: false,
					asNavFor: '#smsthumbnailgallery-slider-' + $(this).data('slider'),
					controlNav: false,
					itemMargin: 1,
					itemWidth: 120,
					mousewheel: true,
					pausePlay: true,
					rtl: false,
					slideshow: false
				});
			} else {
				// Slider
				$(this).flexslider({
					animation: "slide",
					animationLoop: false,
					controlNav: true,
					mousewheel: false,
					rtl: false,
					slideshow: false,
					smoothHeight: true,
					start: function () {
						$('body').removeClass('loading');
						changeHeight(that);
					},
					before: function () {
						$('ol.flex-control-nav', that).each(function (slider) {
							$(this).addClass('hide');
						});
					},
					after: function () {
						changeHeight(that);
						$('div.flex-caption', that).each(function (slider) {
							// undo css side effect from old plugins:
							$(this).css("bottom", "0");
						});
					},
					sync: '#smsthumbnailgallery-carousel-' + $(this).data('carousel')
				});
				$(window).resize(function () {
					changeHeight(that);
				});
			}
		});
	});

});
